import { useNavigate } from "react-router-dom";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { INITIAL_STATUS_CARD } from "constants/home";
import { routes } from "constants/routes";
import { useUserFeature } from "hooks/useUserFeature";
import styles from "./style.module.scss";

export default function HomeInitialStatusCard() {
  const navigate = useNavigate();
  const { isFactoringApproved } = useUserFeature();

  const goToHaulPay = () => {
    navigate(isFactoringApproved !== null ? routes.HAULPAY_STATUS : routes.HAULPAY_JOIN);
  };

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay, EffectFade]}
      effect={"fade"}
      loop={true}
      touchStartPreventDefault={false}
      threshold={10}
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      }}
      pagination={{
        clickable: true
      }}
      className="fade max-w-full mb-5 !overflow-visible home-status-card">
      {INITIAL_STATUS_CARD.map((item) => (
        <SwiperSlide key={item.id}>
          <div className={styles.homeInitialStatusCardContainer}>
            <span className="text-3xl font-bold">{item.title}</span>
            <span className="pt-1 text-sm">{item.content}</span>
            <item.icon className={styles.blendIcon} />

            <button className={styles.joinBackground} onClick={goToHaulPay}>
              <span className={styles.joinButton}>Apply Today</span>
            </button>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
